













































































import { Component, Prop, Vue } from "vue-property-decorator";
import VideoLinks from "@/components/VideoLinks.vue";

@Component({
  components: {
    VideoLinks
  }
})
export default class LeftBar extends Vue {
  @Prop({ default: true }) showDiscord!: boolean;
  @Prop({ default: false }) showPaypal!: boolean;
  @Prop({ default: false }) showVideo!: boolean;

  isDevelopment() {
    return process.env.NODE_ENV === "development";
  }
}
